export const environment = {
    production: false,
    apiUrl: 'https://colony-admin-stg.transnetyx.com/api',

    auth0: {
        domain: 'login-stg.transnetyx.com',
        clientId: 'kHdx7cCgZvbwBMwO4PuW820XwE6wWx1i',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-stg.transnetyx.com/v2/logout/colony`,
        logoutUrl: 'https://login-stg.transnetyx.com/v2/logout',
    },

    accountsUrl: 'https://accounts-stg.transnetyx.com/',
    geneticMonitoring: 'https://quickorder-stg.transnetyx.com/MVC/GeneticMonitoring',
    microbiome: 'https://quickorder-stg.transnetyx.com/MVC/Microbiome',
    supportHubUrl: 'https://www.transnetyx.com/support',
    quickorder: 'https://quickorder-stg.transnetyx.com/home',

    colonyNotificationsUrl: 'https://colony-stg.transnetyx.com/Notifications',
    colonyOrdersCartUrl: 'https://colony-stg.transnetyx.com/Orders/Cart',
    colonyUrlDashboard: 'https://colony-stg.transnetyx.com',
    colonyUrlStrains: 'https://colony-stg.transnetyx.com/Strains',
    colonyUrlGeneMutations: 'https://colony-stg.transnetyx.com/Mutations',
    colonyUrlMice: 'https://colony-stg.transnetyx.com/Mice/MiceList',
    colonyUrlBreedings: 'https://colony-stg.transnetyx.com/Breedings',
    colonyUrlLitters: 'https://colony-stg.transnetyx.com/Litters',
    colonyUrlCages: 'https://colony-stg.transnetyx.com/Cage',
    colonyUrlCagesMapView: 'https://colony-stg.transnetyx.com/Cage/Cages',
    colonyUrlCagesList: 'https://colony-stg.transnetyx.com/Cage/CageList',
    colonyUrlCagesWorkbench: 'https://colony-stg.transnetyx.com/Cage/Workbench',
    colonyUrlTasks: 'https://colony-stg.transnetyx.com/Tasks',
    colonyUrlAmi: 'https://colony-stg.transnetyx.com/Ami/Projects',
    colonyUrlAmiCalculator: 'https://colony-stg.transnetyx.com/AmiCalculator',
    colonyUrlAdministrationUsers: 'https://colony-stg.transnetyx.com/Admin/User',
    colonyUrlAdministrationGroups: 'https://colony-stg.transnetyx.com/Admin/Group',
    colonyUrlAdministrationAuditLog: 'https://colony-stg.transnetyx.com/Admin/AuditLogSearch',
    colonyUrlAdministrationMouseImport: 'https://colony-stg.transnetyx.com/Mice/ImportAdmin',
    colonyUrlAdministrationReloadGroupData: 'https://colony-stg.transnetyx.com/Admin/Group/ResetGroups',
    colonyUrlAdministrationBannerMaintenance: 'https://colony-stg.transnetyx.com/Admin/Banner/Details',
    colonyUrlAdministrationScheduledJobs: 'https://colonyhangfirestg.azurewebsites.net/hangfire',
};
